import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose, withState, withActions } from "containers/HOC";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import RiparianStripDetails from "./RiparianStripDetails";
import * as utils from "common/utils";
import * as domain from "common/domain";
import { submitRiparianStrip } from "./_actions";

class RiparianStripEdit extends Component {
    submit(block) {
        this.props.submitRiparianStrip(this.props.farm.id, this.props.budget.id, block);
    }

    render() {
        const { farm, budget } = this.props;
        return (
            <Tile>
                <PageTabs farmId={farm.id} budget={budget} tab={TAB.WETLANDS} />
                <TileBody>
                    <RiparianStripDetails farm={farm} budget={budget} riparianStrip={this.props.riparianStrip} block={this.props.block} refData={this.props.refData} location={this.props.location} isNew={false} showQuickTips={this.props.showQuickTips} submit={this.submit.bind(this)} history={this.props.history} />
                </TileBody>
            </Tile>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        const blockId = ownProps.match.params.blockId;
        const blocks = ownProps.budget ? ownProps.budget.blocks.filter((b) => b.type !== domain.BlockType.FodderCrop) : [];
        if (!blockId || blocks.length === 0) return;
        const block = utils.clone(blocks.find((b) => b.id === blockId));
        if (!block) return;

        const riparianStrip = block.riparianStrip || domain.factoryRiparianStrip();
        return {
            refData: state.app.refData,
            block,
            riparianStrip,
        };
    }),
    withActions({ submitRiparianStrip })
)(RiparianStripEdit);
